import { React, useEffect, useState } from "react";
import Main from "../layout/Main";
import {
  Badge,
  Card,
  Col,
  Row,
  Button,
  FormLabel,
  FormControl,
  Form,
  Container,
  Stack,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "./Dashboard.css";
import BarChart from "./BarChart";
import LineChart from "./LineChart";
import LineChartAMC from "./LineChartAMC";
import PieChart from "./PieChart";
import DonutChart from "./DonutChart";
import solisPowerApi from "../../api/solisPowerApi";
import EventEdit from "./EventEdit";
import LeadTableDashboard from "./LeadTableDashboard";
import { WarrantyTableDashboard } from "./DashboardTables";
import { ROUTES } from "../../constants/webRouting";
import DashboardNew from "./DashboardNew";
import DateRangePicker from "rsuite/DateRangePicker";
// (Optional) Import component styles. If you are using Less, import the `index.less` file.
import "rsuite/DateRangePicker/styles/index.css";
import { formatDate, getUserDetails } from "../../utils/helper";
import * as constants from "../../constants/CONSTANT";
import PERMISSIONS from "../../constants/permissions";
import SupersetDashboard from "../SupersetDashboard";
// import { useNavigate } from "react-router-dom";
// import { ROUTES } from "../../constants/webRouting";

const Dashboard = () => {
  const navigate = useNavigate();
  const userInfo = getUserDetails();
  const [panelData, setPanelData] = useState({});
  const [dateRange, setDateRange] = useState([
    // new Date(),
    // new Date()
  ]);
  // const [leadsUserWise, setLeadsUserWise] = useState([]);
  // const [leadCount, setLeadCount] = useState(0);
  // const [offerUnits, setOfferUnits] = useState(null);
  // const [totalUnitsordersReceived, setTotalUnitsordersReceived] = useState(0);
  // const [totalUnitsOfWarranty, setTotalUnitsOfWarranty] = useState(0);
  // const [orderUnits, setOrderUnits] = useState([]);
  // const [totalOrderRevenue, setTotalOrderRevenue] = useState(null);
  // const [totalAMCRevenue, setTotalAMCRevenue] = useState(0);
  // const [lostLeads, setLostLeads] = useState([]);
  // const [amcCount, setAmcCount] = useState(null);
  // const [todayMeetings, setTodayMeetings] = useState([]);
  const [showEventModel, setShowEventModel] = useState(false);
  const [filterDate, setFilterDate] = useState({});

  // Fixed by Farhan Khan on 31-Jan-2026 - Role-based redirect protection for Home
  useEffect(() => {
    // Check user role on component mount (handles page refresh/direct access)
    if (userInfo) {
      const userRole = userInfo?.userrole || userInfo?.role || userInfo?.user_role || null;
      // If user is not Super Admin, redirect to Lead List
      if (userRole !== constants.SUPER_ADMIN && userRole !== 'SUPER_ADMIN') {
        navigate(ROUTES.LEAD.LIST);
      }
    }
  }, [navigate, userInfo]);


  useEffect(() => {
    console.log('dateRange', dateRange);
    init();
  }, [dateRange]);


  async function init() {
    try {
      const filterDate = {};
      if (Array.isArray(dateRange)) {
        const [fromDate, toDate] = dateRange;
        if (fromDate && toDate) {
          filterDate.fromDate = formatDate(fromDate);
          filterDate.toDate = formatDate(toDate);
        }
      }

      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_LEAD, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await solisPowerApi.fetchLeadCount(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'newEnquires': result?.at(0)?.total_new_enquires }));
        } else {
          setPanelData((pre) => ({ ...pre, 'newEnquires': '' }));
        }
      }
      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_SITE_VISIT, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await solisPowerApi.fetchSiteVisits(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (Array.isArray(result)) {
          setPanelData((pre) => ({ ...pre, 'siteVisits': result }));
        } else {
          setPanelData((pre) => ({ ...pre, 'siteVisits': [] }));
        }
      }

      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_OFFER, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await solisPowerApi.fetchOfferUnitsTotal(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (Array.isArray(result)) {
          setPanelData((pre) => ({ ...pre, 'offers': result }));
        } else {
          setPanelData((pre) => ({ ...pre, 'offers': [] }));
        }
      }

      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_ORDER, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await solisPowerApi.fetchTotalOrdersReceived(Object.keys(filterDate).length > 0 ? filterDate : null);
        if (Array.isArray(result)) {
          setPanelData((pre) => ({ ...pre, 'orders': result }));
        } else {
          setPanelData((pre) => ({ ...pre, 'orders': [] }));
        }
      }

      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_WARRANTY, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await solisPowerApi.fetchTotalHandovers(Object.keys(filterDate).length > 0 ? filterDate : null);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'totalHandovers': (Number(result?.at(0)?.total_handovers) || 0) }));
        } else {
          setPanelData((pre) => ({ ...pre, 'totalHandovers': 0 }));
        }
      }

      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_WARRANTY, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await solisPowerApi.fetchWarrantyDue(Object.keys(filterDate).length > 0 ? filterDate : null);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'warrantyDue': (Number(result?.at(0)?.warranty_due) || 0) }));
        } else {
          setPanelData((pre) => ({ ...pre, 'warrantyDue': 0 }));
        }
      }

      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_AMC, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await solisPowerApi.fetchAMCDue(Object.keys(filterDate).length > 0 ? filterDate : null);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'amcDue': (Number(result?.at(0)?.amc_due) || 0) }));
        } else {
          setPanelData((pre) => ({ ...pre, 'amcDue': 0 }));
        }
      }

      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_ORDER, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await solisPowerApi.fetchTotalOrderRevenue(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'orderRevenue': (parseFloat((Number(result?.at(0)?.order_revenue) || 0) / 100000)?.toFixed(2)) }));
        } else {
          setPanelData((pre) => ({ ...pre, 'orderRevenue': 0 }));
        }
      }

      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_ORDER, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await solisPowerApi.fetchTotalAMCRevenue(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'amcRevenue': (parseFloat((Number(result?.at(0)?.amc_revenue) || 0) / 100000)?.toFixed(2)) }));
        } else {
          setPanelData((pre) => ({ ...pre, 'amcRevenue': 0 }));
        }
      }

      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_AMC, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await solisPowerApi.fetchAMCTotal(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'unitsInAMC': result?.at(0)?.total_amc_units }));
        } else {
          setPanelData((pre) => ({ ...pre, 'unitsInAMC': '' }));
        }
      }

      if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_WARRANTY, PERMISSIONS.VIEW_DASHBOARD].some(permission => {
        return userInfo?.permissions.map(p => p.name).includes(permission);
      })) {
        let result = await solisPowerApi.fetchTotalUnitsInWarranty(Object.keys(filterDate).length > 0 ? filterDate : null);
        // console.log('result',result);
        if (result) {
          setPanelData((pre) => ({ ...pre, 'unitsInWarranty': result?.at(0)?.total_warranty_units }));
        } else {
          setPanelData((pre) => ({ ...pre, 'unitsInWarranty': '' }));
        }
      }


      // const fetchLeadsUserWise = 0; // await solisPowerApi.fetchLeadUserWise(filterDate);


    } catch (error) {
      console.error("Error fetching leads:", error);
    }
  }

  const submitEvents = async (eventRec) => {
    ////console.log('eventRec home submit', eventRec)
    setShowEventModel(false);
    init();
  };

  return (
    <>
      <SupersetDashboard
        supersetDashboardUUID="93801a0a-3e4f-4ae0-b3d5-bcd38817a5e9"
      />
      {/* <Row>
             <Col lg={6} >
            <Card>
              <Card.Body>
                <div style={{ marginBottom: "10px" }}>
                  <div style={{ display: "flex", marginBottom: "10px" }}>
                    <div style={{ width: "90%" }}>
                      <h4 className="text-center">STAFF WISE SITE VIIST REPORT</h4>
                      <PieChart />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "10px",
                    }}
                  ></div>
                </div>
              </Card.Body>
            </Card>
          </Col>
             <Col lg={6} >
            <Card>
              <Card.Body>
                <div style={{ marginBottom: "9px" }}>
                  <div style={{ display: "flex", marginBottom: "8px" }}>
                    <div style={{ width: "100%" }}>
                      <h4 className="text-center">LEAD REPORT</h4>
                      <LineChart/>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "8px",
                    }}
                  ></div>
                </div>
              </Card.Body>
            </Card>
          </Col>
         </Row> */}
    </>
  );
};

export default Dashboard;
